import { CaseListingInstanceState } from 'app/area/case-report/case-listing/types-store';
import { ApplicationState } from 'app/types-store';

export const selectCaseListingInstanceState = (caseListingInstanceKey: string) => (state: ApplicationState): CaseListingInstanceState =>
  state?.caseListing?.instances?.[caseListingInstanceKey];

export const selectCachedUiDefinition = (caseListingInstanceKey: string, caseTypeId: number, caseContextId: number) =>
  (state: ApplicationState) => selectCaseListingInstanceState(caseListingInstanceKey)(state)?.uiDefinitions?.find(def =>
    !def.fetching && def.caseTypeId === caseTypeId && def.caseContextId === caseContextId
  );

export const selectCasePermissions = (caseListingInstanceKey: string, caseNumber: number) =>
  (state: ApplicationState) => selectCaseListingInstanceState(caseListingInstanceKey)(state)?.permissions?.[caseNumber];

export const selectCaseResults = (caseListingInstanceKey: string) =>
  (state: ApplicationState) => selectCaseListingInstanceState(caseListingInstanceKey)(state)?.results;

export const selectCaseResult = (caseListingInstanceKey: string, caseNumber: number, entityId: number, entityStoreKey: string) =>
  (state: ApplicationState) => selectCaseResults(caseListingInstanceKey)(state)?.find(e =>
    e.caseNumber === caseNumber && e.entityId === entityId && e.entityStoreKey === entityStoreKey
  );

export const selectFetching = (caseListingInstanceKey: string) =>
  (state: ApplicationState) => selectCaseListingInstanceState(caseListingInstanceKey)(state)?.fetching;

export const selectTotalNumberOfResults = (caseListingInstanceKey: string) =>
  (state: ApplicationState) => selectCaseListingInstanceState(caseListingInstanceKey)(state)?.totalNumberOfResults;

export const selectErrorsExecuteFailed = (caseListingInstanceKey: string) =>
  (state: ApplicationState) => selectCaseListingInstanceState(caseListingInstanceKey)(state)?.errorsExecuteFailed;

export const selectRenderMode = (caseListingInstanceKey: string) =>
  (state: ApplicationState) => selectCaseListingInstanceState(caseListingInstanceKey)(state)?.renderMode;
